import { Component, HostListener, inject, Input, OnInit } from "@angular/core";

import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterModule,
} from "@angular/router";

import { filter } from "rxjs";

import { NgFor, NgIf } from "@angular/common";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { HttpClient } from "@angular/common/http";

import Swal from "sweetalert2";

import { GloButtonComponent } from "../glo-button/glo-button.component";

import type { MenuItem } from "../../models/menu-item.model";

import { AuthService } from "../../../shared/services/auth.service";

import { WebSocketsService } from "../../services/web-sockets.service";

import { BusinessSalonContextService } from "../../services/api/business-salon-context.service";

import { environment } from "../../../../environments/environment";

@Component({
  selector: "left-menu",

  standalone: true,

  imports: [GloButtonComponent, RouterModule, NgFor, NgIf, RouterLink],

  templateUrl: "./left-menu.component.html",

  styleUrl: "./left-menu.component.scss",
})
export class LeftMenuComponent implements OnInit {
  private dialogData = inject(MAT_DIALOG_DATA, {
    optional: true,
  });

  private authService = inject(AuthService);

  readonly salonContext = inject(BusinessSalonContextService);

  @Input()
  menuItems: MenuItem[] = [];

  @Input()
  showPoints = true;

  apiUrl = environment.apiUrl;

  assetUrl = environment.assetBaseUrl;

  isBusiness = false;

  ratingProgress = 30;

  user: any = null;

  salonMenuOpen = false;

  constructor(
    private router: Router,

    private http: HttpClient,

    private socketService: WebSocketsService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const basePath = this.router.url.split("/")[1];

        this.isBusiness =
          basePath === "dashboard-business" || basePath === "admin";
      });
  }

  ngOnInit(): void {
    if (this.menuItems.length === 0 && this.dialogData?.items) {
      this.menuItems = [...this.dialogData.items];
    }

    this.loadUserProfile();
  }

  /*
   * ======================================================
   * User
   * ======================================================
   */

  private loadUserProfile(): void {
    this.http
      .get(this.apiUrl + "/auth/me", {
        headers: this.authService.getAuthHeaders(),
      })
      .subscribe({
        next: (user: any) => {
          this.user = user;

          this.addBusinessMenuItems(user);
        },

        error: (error) => {
          console.error("Error fetching user profile:", error);

          Swal.fire({
            title: "Failed to load user profile",

            text: "Something went wrong, please try again.",

            icon: "error",

            timer: 5000,

            showConfirmButton: false,

            toast: true,

            position: "top-end",
          });
        },
      });
  }

  /*
   * ======================================================
   * Salon selector
   * ======================================================
   */

  get canSelectSalons(): boolean {
    return this.user?.role_name === "business_owner";
  }

  toggleSalonMenu(event?: MouseEvent): void {
    event?.stopPropagation();

    if (!this.canSelectSalons) {
      return;
    }

    this.salonMenuOpen = !this.salonMenuOpen;
  }

  toggleAllSalons(event?: MouseEvent): void {
    event?.stopPropagation();

    this.salonContext.toggleAll();
  }

  toggleSalon(salonId: string, event?: MouseEvent): void {
    event?.stopPropagation();

    this.salonContext.toggleSalon(salonId);
  }

  isSalonSelected(salonId: string): boolean {
    return this.salonContext.isSelected(salonId);
  }

  @HostListener("document:click")
  onDocumentClick(): void {
    this.salonMenuOpen = false;
  }

  /*
   * ======================================================
   * Business menu
   * ======================================================
   */

  private addBusinessMenuItems(user: any): void {
    if (user?.role_name !== "business_owner") {
      return;
    }

    const salonsLink = "/admin/business/saloons";

    const alreadyExists = this.menuItems.some(
      (item) => item.link === salonsLink,
    );

    if (alreadyExists) {
      return;
    }

    const salonsItem: MenuItem = {
      label: "Salons",

      link: salonsLink,

      icon: this.assetUrl + "icons/settings.svg",

      alt: "Salons",
    };

    this.menuItems.splice(1, 0, salonsItem);
  }

  openSupport(): void {
    this.router.navigateByUrl("/support");
  }

  /*
   * ======================================================
   * Logout
   * ======================================================
   */

  onLogout(): void {
    localStorage.removeItem("access_token");

    localStorage.removeItem("gloget_business_selected_salons");

    this.socketService.disconnect();

    Swal.fire({
      title: "Logout Successful",

      icon: "success",

      timer: 5000,

      showConfirmButton: false,

      toast: true,

      position: "top-end",
    });
    this.router.navigateByUrl("/login");

    // if (this.isBusiness) {
    //   this.router.navigateByUrl("/business-login");
    // } else {
    //   this.router.navigateByUrl("/login");
    // }
  }
}
